
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'AgeLimit0'
})
export default class AgeLimit0 extends Vue {}
